// Type-safe access to Node.js process global (may not exist in browser)
const getNodeEnv = (): Record<string, string | undefined> | undefined => {
  const g = globalThis as any;
  return g.process?.env;
};

/**
 * Get the API URL override from environment variable.
 * This allows local development to point to a different API server.
 *
 * For Vite apps (admin, web client-side):
 * - Set VITE_API_URL in .env file in the respective app folder
 *
 * For web app server-side (SSR):
 * - The server.mjs reads VITE_API_URL from dotenv
 *
 * @returns The override API URL or undefined if not set
 */
export const getApiUrlOverride = (): string | undefined => {
  // In Vite apps, environment variables prefixed with VITE_ are exposed via import.meta.env
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // In Node.js (SSR), check process.env
  const env = getNodeEnv();
  if (env?.VITE_API_URL) {
    return env.VITE_API_URL;
  }

  return undefined;
};
